export default {
  form: {
    header: {
      label: 'En-tête',
      placeholder: 'En-tête',
    },
    qr_code_header: {
      label: 'Titre de la boîte UI',
      placeholder: 'Titre de la boîte UI',
    },
    qr_code_description: {
      label: 'Description de la boîte UI',
      placeholder: 'Description de la boîte UI',
    },
    tag_text: {
      label: 'Texte du tag',
      placeholder: 'NOUVEAU !',
    },
    footer: {
      label: 'Texte de pied de page',
      placeholder: 'Saisir le texte de pied de page',
    },
    url_type: {
      label: 'URL',
      placeholder: 'Sélectionner une URL',
    },
    url: {
      placeholder: 'www.example.com',
    },
    primary_color: {
      label: 'Couleur principale',
    },
    background_color: {
      label: "Couleur d'arrière-plan",
    },
    logo: {
      label: 'Logo',
    },
  },
  toasts: {
    failed_to_load_data: 'Échec du chargement du flyer',
  },
};
